import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hr-customers-shell',
  templateUrl: './customers-shell.component.html',
  styleUrls: ['./customers-shell.component.less'],
  standalone: false,
})
export class CustomersShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
